import Swal from 'sweetalert2'

export const InfoDialog = ({ text }) => {
  Swal.fire({ text: text, position: 'center' })
}